import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { homeCardsConfig } from './ai-home.config';
import { RappiderCardsModule } from '@rappider/rappider-components';
import { ButtonSize, HeadingType, IconType, NgZorroIconTheme } from '@rappider/rappider-components/utils';

@Component({
  selector: 'rappider-ai-home',
  standalone: true,
  imports: [
    RappiderCardsModule
  ],
  templateUrl: './ai-home.component.html',
  styleUrls: ['./ai-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RappiderAiHomeComponent implements OnInit {

  models: any[] = [
    {
      title: 'Model 1',
      description: 'Description for Model 1',
    },
    {
      title: 'Model 2',
      description: 'Description for Model 2',
    },
    {
      title: 'Model 3',
      description: 'Description for Model 3',
    },
    {
      title: 'Model 4',
      description: 'Description for Model 4',
    },
    {
      title: 'Model 5',
      description: 'Description for Model 5',
    },
    {
      title: 'Model 6',
      description: 'Description for Model 6',
    },
    {
      title: 'Model 7',
      description: 'Description for Model 7',
    },
    {
      title: 'Model 8',
      description: 'Description for Model 8',
    },
    {
      title: 'Model 9',
      description: 'Description for Model 9',
    },
    {
      title: 'Model 10',
      description: 'Description for Model 10',
    }
  ];


  homeCardsConfig = cloneDeep(homeCardsConfig);
  selectedModelCardId: string | undefined;


  ngOnInit() {
    this.mapModelsToCardConfig();
  }

  onCardDetailClicked(cardId: string) {
    console.log('Card detail clicked:', cardId);
    this.selectedModelCardId = cardId;
  }

  onCardSelected(cardId: string) {
    console.log('Card selected:', cardId);
    this.selectedModelCardId = cardId;
  }

  mapModelsToCardConfig() {
    if (this.models?.length) {
      this.homeCardsConfig.cardsConfig.items = this.models?.map(model => ({
        data: model,
        type: 'layout',
        titles: [
          {
            type: HeadingType.H4,
            content: model.title
          }
        ],
        descriptions: [
          {
            typography: {
              fontSize: 'var(--subtext-font-size)'
            },
            content: model.description
          }
        ],
        isTooltipEnabledOnDescription: true,
        image: null,
        image2: {
          source: model?.thumbnails?.length > 0 ?
            model.thumbnails[0].url : 'assets/img/page-templates/profile-template1-thumbnail.png'
        },
        imageTags: [{}],
        imageButtons: [],
        imageButtons2: [{
          name: 'preview-layout',
          icon: {
            name: 'eye',
            type: IconType.NgZorro,
            theme: NgZorroIconTheme.Outline
          },
          customColorSettings: {
            backgroundColor: 'var(--section-background-color)',
            color: 'var(--text-color)'
          },
          shadowSettings: {
            boxShadow: '0 0 0 var(--section-background-color)'
          },
          borderSettings: {
            borderColor: 'transparent'
          },
          size: ButtonSize.Small,
          tooltipText: 'Preview'
        },
        {
          icon: {
            name: 'check',
            type: IconType.NgZorro,
            theme: NgZorroIconTheme.Outline
          },
          name: 'set-active-layout',
          customColorSettings: {
            backgroundColor: 'var(--section-background-color)',
            color: 'var(--text-color)'
          },
          shadowSettings: {
            boxShadow: '0 0 0 var(--section-background-color)'
          },
          borderSettings: {
            borderColor: 'transparent'
          },
          size: ButtonSize.Small,
          tooltipText: 'Set as Active Layout'
        }],
      })) as any;
    }
  }

}
